import { ContainerModule, interfaces } from 'inversify'
import { IncidentStore } from '@compliance/modules/IncidentStore'
import { DY_TYPES } from '@compliance/di/serviceIdentifiers'

export const incidentStoreModule = () =>
  new ContainerModule((bind: interfaces.Bind) => {
    bind<IncidentStore>(DY_TYPES.IncidentStore).to(IncidentStore)
  })
